import createClient from 'openapi-fetch';
import type { paths } from '../generated/canvas-api-types';

export function getCanvasApiBaseUrl(): string {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  // Same-origin by default in production builds — UI and canvas-api share
  // canvas.containerlabs.io behind one host. Dev falls back to localhost.
  return process.env.NODE_ENV === 'development' ? 'http://localhost:8001' : '';
}

export function createCanvasClient() {
  return createClient<paths>({
    baseUrl: getCanvasApiBaseUrl(),
    credentials: 'include',
  });
}

export type CanvasClient = ReturnType<typeof createCanvasClient>;

export type LegacyApiResponse<T> = { body: T; response: Response };

type ApiError = Error & {
  response?: { status: number; data: unknown };
};

/** Normalize openapi-fetch results to the legacy `{ body }` shape used across the UI. */
export function asLegacyResponse<T>(
  result: { data?: T; error?: unknown; response: Response }
): LegacyApiResponse<T> {
  const { data, error, response } = result;
  if (!response.ok) {
    const err = new Error(response.statusText || 'Request failed') as ApiError;
    err.response = { status: response.status, data: error };
    throw err;
  }
  return { body: data as T, response };
}

export function handleApiError(error: unknown): void {
  console.error('API Error:', error);
  const err = error as ApiError;
  if (err.response) {
    console.error('Response data:', err.response.data);
    console.error('Response status:', err.response.status);
  } else if ((error as { request?: unknown }).request) {
    console.error('No response received:', (error as { request: unknown }).request);
  } else {
    console.error('Error setting up request:', (error as Error).message);
  }
}
